import script from "./CreateJobTemplate.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateJobTemplate.vue?vue&type=script&setup=true&lang=ts"

import "./CreateJobTemplate.vue?vue&type=style&index=0&id=fa024642&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fa024642"]])

export default __exports__